import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import localforage from "localforage";
import authReducer from "./slices/authSlice";
import workOrdersReducer from "./slices/workOrderSlice";
import workOrderDetailReducer from "./slices/workOrderDetailSlice";
import inspectionTemplatesReducer from "./slices/inspectionTemplatesSlice";
import pendingUploadsQueueReducer from "./slices/pendingUploadsQueue";
import toasterReducer from "./slices/toasterSlice";
import redirectReducer from "./slices/redirectSlice";
import clarityReducer from './slices/claritySlice';

const rootReducer = combineReducers({
  auth: authReducer,
  workOrders: workOrdersReducer,
  workOrderDetail: workOrderDetailReducer,
  inspectionTemplates: inspectionTemplatesReducer,
  pendingUploadsQueue: pendingUploadsQueueReducer,
  toaster: toasterReducer,
  redirect: redirectReducer,
  clarity: clarityReducer,
});

const persistConfig = {
  key: "root",
  storage: localforage,
  blacklist: ['auth.error'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ thunk: true }),
});

export const persistor = persistStore(store);
export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
